var React = require('react');

function Separator (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector 97","d":"M1 1V40","stroke":"white","strokeOpacity":"0.1","strokeWidth":"2","strokeLinecap":"square"}));
}

Separator.defaultProps = {"width":"2","height":"41","viewBox":"0 0 2 41","fill":"none"};

module.exports = Separator;

Separator.default = Separator;
